const Menuitems = [
  {
    id: 1,
    label: "Dashboard",
    link: "/admin/dashboard",
    requiredRole: "Admin",
  },
  {
    id: 2,
    label: "Users",
    submenus: [
      {
        id: 1,
        label: "All Users",
        link: "/admin/all-users",
        img: "https://res.cloudinary.com/dev6cpp4u/image/upload/v1690181271/invest_yss3bh.png",
        desc: "Hello this is description for the sub menu.",
        requiredRole: "Admin"
      },
      {
        id: 2,
        label: "Edit User",
        link: "/admin/edit-users",
        img: "https://res.cloudinary.com/dev6cpp4u/image/upload/v1690181271/invest_yss3bh.png",
        desc: "Hello this is description for the sub menu.",
        requiredRole: "All"
      }
    ]
  },
  {
    id: 3,
    label: "Package",
    requiredRole: "Admin",
    submenus: [
      {
        id: 1,
        label: "All Packages",
        link: "/admin/get-all-package",
        img: "https://res.cloudinary.com/dev6cpp4u/image/upload/v1690181271/invest_yss3bh.png",
        desc: "Hello this is description for the sub menu."
      }
    ]
  },
  {
    id: 4,
    label: "Hybrid",
    requiredRole: "Admin",
    submenus: [
      {
        id: 1,
        label: "All Hybrid Packages",
        link: "/admin/all-hybrid-packages",
        img: "https://res.cloudinary.com/dev6cpp4u/image/upload/v1690181271/invest_yss3bh.png",
        desc: "Hello this is description for the sub menu."
      },
      {
        id: 6,
        label: "Generate Pins",
        link: "/admin/generate-pins",
        img: "https://res.cloudinary.com/dev6cpp4u/image/upload/v1690181271/invest_yss3bh.png",
        desc: "Generate 4-digit pins for hybrid package activation."
      },
      {
        id: 2,
        label: "Autopool Hybrid Withdrawal",
        link: "/admin/all-hybrid-withdrawals",
        img: "https://res.cloudinary.com/dev6cpp4u/image/upload/v1690181271/invest_yss3bh.png",
        desc: "Hello this is description for the sub menu."
      },
      {
        id: 3,
        label: "Hybrid Balance Withdrawals",
        link: "/admin/all-hybrid-balance-withdrawals",
        img: "https://res.cloudinary.com/dev6cpp4u/image/upload/v1690181271/invest_yss3bh.png",
        desc: "Hello this is description for the sub menu."
      },
      {
        id: 4,
        label: "100 Days Withdrawals",
        link: "/admin/all-hybrid-bonus-withdrawals",
        img: "https://res.cloudinary.com/dev6cpp4u/image/upload/v1690181271/invest_yss3bh.png",
        desc: "Hybrid bonus withdrawals (USDT + retopup + CGT Homes)."
      },
      {
        id: 5,
        label: "Matrix Withdrawals",
        link: "/admin/all-matrix-withdrawals",
        img: "https://res.cloudinary.com/dev6cpp4u/image/upload/v1690181271/invest_yss3bh.png",
        desc: "Matrix stage (HM/Part) claim payouts."
      }
    ]
  },
  {
    id: 5,
    label: "Withdrawal",
    requiredRole: "Admin",
    submenus: [
      {
        id: 1,
        label: "USDT Withdrawal",
        link: "/admin/usdt-withdrawal",
        img: "https://res.cloudinary.com/dev6cpp4u/image/upload/v1690181271/invest_yss3bh.png",
        desc: "Hello this is description for the sub menu."
      },
      {
        id: 2,
        label: "USDT Withdrawal History",
        link: "/admin/usdt-withdrawal-history",
        img: "https://res.cloudinary.com/dev6cpp4u/image/upload/v1690181271/invest_yss3bh.png",
        desc: "Hello this is description for the sub menu."
      }
    ]
  },
  // {
  //   id: 6,
  //   label: "Settings",
  //   link: "/admin/settings",
  //   img: "https://res.cloudinary.com/dev6cpp4u/image/upload/v1690181271/invest_yss3bh.png",
  //   desc: "System configuration and asset management"
  // },
  {
    id: 6,
    label: "Log out",
    link: "/logout",
  }
];

export default Menuitems;